export default __webpack_public_path__ + "static/media/red5.77374350.svg";